module.exports = __webpack_public_path__ + "static/media/first-publish-explain-en.963a6989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/first-publish-explain-en.png
// module id = 1151
// module chunks = 110